
// const SAMPLE_TYPES = [
//   "A - Blood Plasma",
//   "B - Blood Serum",
//   "C - Blood Protein",
//   "D - PAX DNA",
//   "E - PAX RNA",
//   "F - Urine",
//   "G - PMBC",
//   "H - Mitra",
//   "I - Saliva",
// ];
// const SAMPLE_QUALITY = ["Excellent", "Good", "Fair"];

// const getTypeCode = (val) => {
//   if (!val) return "";
//   const s = String(val).trim();
//   return s.split(/[\s-]+/)[0].toUpperCase();
// };
// const labelToCode = (label) => getTypeCode(label);

// const AliquotProcessing = () => {
//   const [selectedTypes, setSelectedTypes] = useState([]);
//   const [selectedQuality, setSelectedQuality] = useState([]);
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const [toast, setToast] = useState(state?.toast || null);

//   useEffect(() => {
//     if (state?.toast) navigate(".", { replace: true, state: {} });
//   }, [state, navigate]);


//   const filteredRows = useMemo(() => {
//     const selectedTypeCodes = selectedTypes.map(labelToCode);
//     return rows.filter((row) => {
//       const byType =
//         selectedTypeCodes.length === 0 ||
//         selectedTypeCodes.includes(row.typeCode);
//       const byQuality =
//         selectedQuality.length === 0 || selectedQuality.includes(row.quality);
//       return byType && byQuality;
//     });
//   }, [rows, selectedTypes, selectedQuality]);


//         const go = () =>
//           navigate(`/aliquot/verify/${encodeURIComponent(params.row.barcode)}`);


//   const handleClearFilters = () => {
//     setSelectedTypes([]);
//     setSelectedQuality([]);
//   };






//         <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
//           <Typography
//             sx={{
//               fontSize: 26,
//               fontWeight: 600,
//               color: "#500000",
//               textAlign: "left",
//               mb: 1,
//             }}
//           >
//             Available Samples
//           </Typography>



// export default AliquotProcessing;

import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Paper,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Snackbar,
  Alert,
  Button,
  Stack,
} from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import StyledDataGrid from "../../../components/StyledDataGrid";
import WorkspacePage from "../../../components/WorkspacePage";
import {
  Add as AddIcon,
  Refresh as RefreshIcon,
  FilterAlt as FilterAltIcon,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchSamplesPaged } from "../../../utils/api";
import { getSampleTypeFamily } from "../../../utils/sampleIds";
import { BIOBANK_ROUTES, BIOBANK_SUB_ROUTES } from "../../../constants/routes";

const SAMPLE_TYPES = [
  "A - Blood Plasma",
  "B - Blood Serum",
  "C - Blood Protein",
  "D - PAX DNA",
  "E - PAX RNA",
  "F - Urine",
  "G - PBMC",
  "H - Mitra",
  "I - Saliva",
];
const SAMPLE_QUALITY = ["Excellent", "Good", "Fair"];

const getTypeCode = (val) => {
  if (!val) return "";
  const s = String(val).trim();
  return getSampleTypeFamily(s.split(/[\s-]+/)[0]);
};
const labelToCode = (label) => getTypeCode(label);

const AliquotProcessing = () => {
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedQuality, setSelectedQuality] = useState([]);
  const [rows, setRows] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { state } = useLocation();
  const [toast, setToast] = useState(state?.toast || null);

  useEffect(() => {
    if (state?.toast) navigate(".", { replace: true, state: {} });
  }, [state, navigate]);

  const selectedTypeCodes = useMemo(
    () => selectedTypes.map(labelToCode).filter((code) => !!code),
    [selectedTypes]
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const response = await fetchSamplesPaged({
          page: paginationModel.page,
          size: paginationModel.pageSize,
          // Keep legacy behavior: show only samples that still need aliquot processing.
          unprocessedOnly: true,
          sampleTypes: selectedTypeCodes,
          qualities: selectedQuality,
        });
        const samples = Array.isArray(response?.content) ? response.content : [];
        if (cancelled) return;
        const formatted = (samples || []).map((s, index) => {
          const typeRaw = s?.sampleType || "N/A";
          return {
            id: s?.sampleId || `sample-${index}`,
            barcode: s?.sampleId || "N/A",
            quality: s?.sampleQuality || "N/A",
            type: typeRaw,
            typeCode: getTypeCode(typeRaw),
            processedAliquots: s?.processedAliquots ?? null,
          };
        });
        setRows(formatted);
        setTotalRowCount(response?.totalElements || 0);
      } catch (err) {
        console.error("Failed to load samples:", err);
        setRows([]);
        setTotalRowCount(0);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    paginationModel.page,
    paginationModel.pageSize,
    selectedTypeCodes,
    selectedQuality,
  ]);

  const columns = [
    {
      field: "barcode",
      headerName: "Barcode ID",
      flex: 1,
    },
    {
      field: "quality",
      headerName: "Sample Quality",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Check-In Status",
      flex: 1,
      renderCell: (params) => {
        const go = () =>
          navigate(BIOBANK_SUB_ROUTES.SAMPLE_PROCESSING_VERIFY(encodeURIComponent(params.row.barcode)), {
            state: { returnTo: BIOBANK_ROUTES.SAMPLE_PROCESSING },
          });

        return (
          <Button
            onClick={go}
            variant="contained"
            sx={{
              width: "175px",
              height: "32px",
              fontSize: "13px",
              fontWeight: 600,
              whiteSpace: "nowrap",
              bgcolor: "#500000",
              color: "#fff",
              border: "1px solid #400000",
              "&:hover": { bgcolor: "#6a0000" },
              borderRadius: "10px",
            }}
          >
            PROCESS SAMPLE
          </Button>
        );
      },
    },
  ];

  const handleClearFilters = () => {
    setSelectedTypes([]);
    setSelectedQuality([]);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  return (
    <WorkspacePage>
      <PageHeader title="Sample Processing" />

      {/* Two Column Layout */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flex: 1,
          minHeight: 0,
        }}
      >
        {/* Left Panel - Filters */}
        <Box
          sx={{
            width: 250,
            flexShrink: 0,
            backgroundColor: "white",
            border: "1px solid #000",
            borderRadius: 0,
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            overflowY: "auto",
              "& .MuiFormControlLabel-root": { margin: 0 },
              "& .MuiFormControlLabel-label": { fontSize: "0.875rem", lineHeight: 1.5 },
            }}
            data-tour-id="tour-processing-filters"
          >
            {/* Scrollable Content Area */}
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden",
                pr: 1,
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#ccc",
                  borderRadius: "3px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#999",
                },
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}
            >
              {/* Sample Type Filter */}
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <FilterAltIcon sx={{ color: "#500000", fontSize: 20 }} />
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: "#500000" }}
                  >
                    Sample Type
                  </Typography>
                </Box>
                <Divider sx={{ mb: 1 }} />
                <Stack spacing={0.5}>
                  {SAMPLE_TYPES.map((type) => (
                    <FormControlLabel
                      key={type}
                      control={
                        <Checkbox
                          checked={selectedTypes.includes(type)}
                          onChange={(e) =>
                            setSelectedTypes((prev) => {
                              const next = e.target.checked
                                ? [...prev, type]
                                : prev.filter((t) => t !== type);
                              setPaginationModel((model) => ({
                                ...model,
                                page: 0,
                              }));
                              return next;
                            })
                          }
                          size="small"
                        />
                      }
                      label={type}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "0.875rem",
                        },
                      }}
                    />
                  ))}
                </Stack>
              </Box>

              {/* Sample Quality Filter */}
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <FilterAltIcon sx={{ color: "#500000", fontSize: 20 }} />
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: "#500000" }}
                  >
                    Sample Quality
                  </Typography>
                </Box>
                <Divider sx={{ mb: 1 }} />
                <Stack spacing={0.5}>
                  {SAMPLE_QUALITY.map((q) => (
                    <FormControlLabel
                      key={q}
                      control={
                        <Checkbox
                          checked={selectedQuality.includes(q)}
                          onChange={(e) =>
                            setSelectedQuality((prev) => {
                              const next = e.target.checked
                                ? [...prev, q]
                                : prev.filter((v) => v !== q);
                              setPaginationModel((model) => ({
                                ...model,
                                page: 0,
                              }));
                              return next;
                            })
                          }
                          size="small"
                        />
                      }
                      label={q}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "0.875rem",
                        },
                      }}
                    />
                  ))}
                </Stack>
              </Box>
            </Box>

            {/* Clear Button */}
            <Box sx={{ mt: "auto", flexShrink: 0 }}>
              <Divider sx={{ mb: 2, width: "100%" }} />
              <Button
                variant="outlined"
                startIcon={<RefreshIcon />}
                onClick={handleClearFilters}
                fullWidth
                sx={{
                  textTransform: "uppercase",
                  borderRadius: 0,
                  borderColor: "#500000",
                  color: "#500000",
                  "&:hover": {
                    borderColor: "#500000",
                    backgroundColor: "rgba(80, 0, 0, 0.06)",
                  },
                }}
              >
                CLEAR
              </Button>
            </Box>
          </Box>

        {/* Right Panel - Data Grid */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >


          {/* Data Grid */}
          <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }} data-tour-id="tour-processing-table">
            <StyledDataGrid
              sx={{ flex: 1 }}
              rows={rows}
              columns={columns}
              loading={loading}
              pagination
              paginationMode="server"
              rowCount={totalRowCount}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 25, 50]}
              disableSelectionOnClick
            />
          </Box>
        </Box>
      </Box>

      <Snackbar
        open={!!toast}
        autoHideDuration={5000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="success"
          onClose={() => setToast(null)}
          variant="filled"
          sx={{ fontWeight: 600 }}
        >
          {toast?.message || "Success"}
        </Alert>
      </Snackbar>
    </WorkspacePage>
  );
};

export default AliquotProcessing;
